module.exports = __webpack_public_path__ + "static/media/bannerMcDonalds.c109244f.jpg";